// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Action } from './action';
import { Admin } from './admin';
import { Asset } from './asset';
import { Document } from './document';
import { Resource } from './resource';
import { TaskAudit } from './task-audit';
import { TaskGroup } from './task-group';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class iTask extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  taskId!: number;
  adminTypeId?: number;
  assignedDate?: Date;
  assignee1ActualUnits?: number;
  assignee1Units?: number;
  assignee1UserId?: number;
  assignee2UserId?: number;
  assignorUserId?: number;
  completedDate!: Date;
  contextId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  displayOrder!: number;
  dueDate?: Date;
  hasDependantTasks!: boolean;
  isDismissed!: boolean;
  isNotified?: boolean;
  isReminded!: boolean;
  isTemplate!: boolean;
  memo?: string;
  precedentDatepart?: string;
  precedentInterval?: number;
  precedentTaskUid?: string;
  precedentType!: number;
  recurrenceDatepart?: string;
  recurrenceInterval?: number;
  recurrenceType!: number;
  reminderDatepart?: string;
  reminderInterval?: number;
  startDate?: Date;
  startDatepart?: string;
  startInterval?: number;
  statusReport?: boolean;
  statusReportUserId?: number;
  taskGroupId?: number;
  taskPriority!: number;
  taskStatus!: number;
  taskUid!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  actions!: Action[];
  assets!: Asset[];
  assignee1User!: User;
  context!: Admin;
  documentAuthorisationTasks!: Document[];
  documentDespatchTasks!: Document[];
  resources!: Resource[];
  taskAudits!: TaskAudit[];
  taskGroup!: TaskGroup;
}

